'use strict';

// Returns inventory cards, used in inventory-vehicle.js
define('lib/transforms/inventory',[
  'jquery',
  'lib/readable-monetize',
  'lib/analytics/blocks/series.block'
], function (
  $,
  readableMonetize,
  seriesBlock
) {
  var __regexDisclaimer = /\[.*?\]/g;

  function __getVehicleJellyImage(jelly) {
    return jelly;
  }

  // EFC series.code does not contain 'hybrid' for hybrid vehicles
  // Tack that on if we need to, so that it matches OUR series data
  // this makes our supplemental related offers more accurate. And our recently viewed vehicles more accurate. Duh
  function __buildSeries(efcSeriesCode, efcGrade) {
    if (efcGrade.indexOf('hybrid') >= 0) {
      return efcSeriesCode + 'hybrid';
    }
    return efcSeriesCode;
  }

  function __cleanText(txt) {
    var results = txt.match(__regexDisclaimer);
    var cleaned = txt;
    if (results) {
      results.forEach(function (dis) {
        cleaned = cleaned.replace(dis, '');
      });
    }
    return cleaned;
  }

  // raw data into vehicleData
  function __extractVehicleData(idx, vehicle) {
    var vehicleData = {};
    var match = ''; // optional vehicle.exactmatch = true/false

    try {
      // vehicleData.idx = idx; // we don't actually use this
      // vehicleData.vin = vehicle.vin;
      vehicleData.match = match;
      vehicleData.modelDescription = vehicle.model.description;
      vehicleData.transmissionCode = vehicle.transmission.code;
      vehicleData.transmissionTitle = vehicle.transmission.title;
      vehicleData.modelCode = vehicle.model.code;
      vehicleData.modelGradeCode = vehicle.model.gradeCode;
      // Handle special cases to add bed and cab to trucks for modelGradeCode to pass to SLP forms
      if (vehicle.series.code === 'tacoma' || vehicle.series.code === 'tundra') {
        vehicleData.modelGradeCode += vehicle.cab.code + vehicle.bed.title;
        vehicleData.modelGradeCode = vehicleData.modelGradeCode.replace(/ /g, '');
      }
      vehicleData.year = vehicle.year.code;
      vehicleData.engineCode = vehicle.engine.code;
      if (vehicle.engine.title !== undefined && vehicle.engine.title !== 'undefined') {
        vehicleData.engineTitle = vehicle.engine.title.replace(/\[(.+?)\]/g, '');
      }
      vehicleData.exteriorColorHex = vehicle.exteriorcolor.hexValue;
      vehicleData.exteriorColorTitle = vehicle.exteriorcolor.title;
      vehicleData.exteriorColorCode = vehicle.exteriorcolor.code;
      vehicleData.jellyImage = vehicle.exteriorcolor.carJellyImage;
      vehicleData.interiorColorSwatch = vehicle.interiorcolor.onSwatchImage;
      vehicleData.interiorSeatImg = vehicle.interiorcolor.interiorSeatImage;
      vehicleData.interiorColorTitle = vehicle.interiorcolor.title;
      vehicleData.interiorColorCode = vehicle.interiorcolor.code;
      vehicleData.msrp = vehicle.msrp; // UI uses 'Starting MSRP', and this value is smaller, so I assume it's the 'Starting MSRP'
      vehicleData._series = vehicle.series.code; // can't rely on this ATM
      vehicleData.series = __buildSeries(vehicle.series.code, vehicle.grade.code);
      vehicleData.totalmsrp = vehicle.model.msrp;// this returns the specific vehicle MSRP (with options). The UI uses 'Starting MSRP',
      vehicleData.options = {}; // Ultimately, these are the "packages" on each vehicle
      vehicleData.optCodes = [];
      vehicleData.standardFeatures = vehicle.series.standardFeatures;

      // if vehicle has exteriorcolor.hexValueArray, then it's a two-toned vehicle
      // add those two colors as follows:
      if (vehicle.exteriorcolor.hexValueArray) {
        vehicleData.exteriorvirtual = {
          name: vehicle.exteriorcolor.title,
          hex: vehicle.exteriorcolor.hexValueArray,
          alt: __cleanText(vehicle.exteriorcolor.title)
        };
      }

      /*-----------------------------------------------------------------------------
      Setup what are ultimately "Packages" on each vehicle
      This strips the disclaimer code from FIO and PIO packages
        - ie: accessory[x].title: "All-Weather Mat Package [installed_msrp]"
        - we do NOT do this on production, but they're using this on their sample page:
          http://next.staging.ws.toyota.com/config/services/pages/SIT-test.html
      -------------------------------------------------------------------------------*/
      if (vehicle.accessory) {
        $.each(vehicle.accessory, function (index, val) {
          var tempObj = {
            code: val.code,
            canFilterOn: true,
            type: val.type
          };

          vehicleData.options[val.code] = val.title.replace(/\[(.+?)\]/g, '');

          if (val.vtc === false) {
            tempObj.canFilterOn = false;
          }

          vehicleData.optCodes.push(tempObj);
        });
      }
    } catch (err) {
      console.error('Error in inventory xform: ', err); // eslint-disable-line no-console
    }

    return vehicleData;
  }

  function __convertVehiclesToCards(vehicles) {
    var cards = [];
    $.each(vehicles, function (indx, result) {
      try {
        var card = __convertVehicleToCard(result);
        cards.push(card);
      } catch (e) {
        console.error('err: ', e);
      }
    });
    return cards;
  }

  // convert the vehicle to something usable by the front end
  // (without altering the Handlebars template (at least for now))
  function __convertVehicleToCard(vehicle) {
    var card = {};
    var accCodeArr = [];
    var accString = ''; // for use in vehicleId, used for filtering

    // for each item in vehicle.optCodes, if vehicle.optCodes[x].canFilterOn is true, then add that as an accessory
    // we still add ALL of these as packages, below
    for (var i = 0; i < vehicle.optCodes.length; i++) {
      if (vehicle.optCodes[i].canFilterOn === true) {
        accCodeArr.push(vehicle.optCodes[i].code);
        if (vehicle.optCodes[i].type === 'FIO') {
          accString = accString + '-PKG+' + vehicle.optCodes[i].code;
        } else {
          accString = accString + '-ACY+' + vehicle.optCodes[i].code;
        }
      }
    }

    card.accessory = {
      codes: accCodeArr // vehicle.optCodes is an array of
    };

    card.color = {
      exterior: {
        code: vehicle.exteriorColorCode,
        hex: vehicle.exteriorColorHex,
        name: vehicle.exteriorColorTitle,
        alt: __cleanText(vehicle.exteriorColorTitle)
      },

      interior: {
        code: vehicle.interiorColorCode,
        img: vehicle.interiorColorSwatch,
        name: vehicle.interiorColorTitle,
        seatimg: vehicle.interiorSeatImg,
        alt: __cleanText(vehicle.interiorColorTitle)
      }
    };

    if (!card.color.interior.code) {
      delete card.color.interior;
    }

    // if vehicle has vehicle.exteriorvirtual, then it's a two toned vehicle
    // add that info to our card, as follows:
    if (vehicle.exteriorvirtual) {
      card.color.exteriorvirtual = vehicle.exteriorvirtual;
    }

    card.engine = vehicle.engineTitle;
    card.formatted_msrp = readableMonetize(vehicle.msrp);
    // card.id = vehicle.vin; // previously this was the old configString (YR_2016 SER_corolla MDL_1831 XCOL_0040 ICOL_FA11 ACY_FE)

    // Build a vehicle id
    var idString = '';
    idString += 'BRD_TOY';
    idString += '-YR_' + vehicle.year;
    idString += '-MDL_' + vehicle.modelCode;
    idString += '-XCOL_' + vehicle.exteriorColorCode;
    idString += '-ICOL_' + vehicle.interiorColorCode;

    if (accString !== '') {
      idString += accString;
    }

    // previously this was the old configString (YR_2016 SER_corolla MDL_1831 XCOL_0040 ICOL_FA11 ACY_FE)
    card.id = idString;

    card.image = __getVehicleJellyImage(vehicle.jellyImage);
    card.modelcode = vehicle.modelCode;
    card.msrp = vehicle.msrp; // drop this from XSL and use formatted?
    card.name = vehicle.modelDescription; // Update XSL to remove name and trim, since this contains both?

    card.packages = [];
    var tmpPackagesForDataLayer = [];
    Object.keys(vehicle.options).forEach(function (key) {
      card.packages.push({
        code: key,
        name: vehicle.options[key]
      });
      tmpPackagesForDataLayer.push(vehicle.options[key].trim());
    });
    card.options = vehicle.options;

    card.dataLayer = seriesBlock({
      series_code: vehicle.series,
      year: vehicle.year,
      trim_code: vehicle.modelCode,
      vehicleid: idString,
      base_msrp: vehicle.msrp.toString(), // matches what we show on FE
      grade: vehicle.modelGradeCode,
      engine: vehicle.engineCode,
      transmission: vehicle.transmissionTitle,
      eries_packages: tmpPackagesForDataLayer.toString().replace("'", ''),
      color_ext: vehicle.exteriorColorTitle.replace(/\[.*?\]/g, ''),
      color_int: vehicle.interiorColorTitle,
      color_ext_code: vehicle.exteriorColorCode,
      color_int_code: vehicle.interiorColorCode,
      accessories_name: tmpPackagesForDataLayer.toString().replace("'", ''),
    });

    card.series = vehicle.series; // old: SER_corolla
    card.transmission = vehicle.transmissionTitle;
    if (vehicle.modelGradeCode) {
      card.trim = vehicle.modelGradeCode; // old : 'L', 'LX', etc - no longer available
    } else {
      card.trim = '';
    }
    card.year = vehicle.year;
    card.yearcode = vehicle.year; // old: YR_2016;
    card.ariaLabel = vehicle.year + ' ' + vehicle.modelDescription;
    // console.log('card:', card);
    return card;
  }

  // options = entire EFC response
  return function transformInv(options) {
    var inventoryObj = options.data.body.response.docs;
    var vehicles = [];
    $.each(inventoryObj, function (idx, vehicle) {
      var vehicleData = __extractVehicleData(idx, vehicle);
      vehicles.push(vehicleData);
    });
    // Convert each formatted vehicle into an even more usable array of 'cards'
    var cards = __convertVehiclesToCards(vehicles);
    return cards;
  };
});

